<template>
	<div>
		<TableList v-bind="getData" @on-radio-change="checkChange"></TableList>
		<div style="height:32px">
			<vButton @click="cancel" class="pull-right margin-left-10">取消</vButton>
			<vButton @click="click" theme="primary" class="pull-right">确定</vButton>
		</div>
	</div>
</template>
<script>
import TableList from "@components/templates/tablelist"
import { 
    HttpNewPlatformCarrier,
    HttpAllTruckLogProdList,
    HttpNewAllTruckLogProdList,
} from "@/service/managechannel/managechannel";
export default {
	props:['warehouseId'],
	components: {
		TableList
	},
    data(){
        return {
            truckCarrierGroupList:[]
        }
    },
    created(){
        // HttpAllTruckLogProdList().then(res=>{
        HttpNewAllTruckLogProdList({
            customerId: global.SYSID
        }).then(res=>{
            this.truckCarrierGroupList = res.data.map((item) => {
                return {
                    // label: item.groupName,
                    // value: item.groupName,
                    label: item.carrierGroupCode,
                    value: item.carrierGroupCode,
                    attach: {
                        type:item.type,
                    },
                };
            });
        },err=>{
            this.$VMessage.error(err.message)
        })
    },
	methods: {
		checkChange(rows, val) {
			this.rows = rows
		},
		click() {
			this.$emit('rows', this.rows)
		},
		cancel(){
			this.$emit('cancel')
		},
	},
	computed: {
		getData() {
			return {
				ajaxRequest: HttpNewPlatformCarrier,
				startUp: true,
                initFormData: {
					"orgWarehouseId":this.warehouseId
				},
                interceptRequest(params){
                    params.groupName = params.search.EQ_carrierGroupName
                    params.code = params.search.CN_code
                    delete params.search.EQ_carrierGroupName
                    delete params.search.CN_code
                    return params
                },
				Searchs: {
					show: true,
					style: "border:none;",
					align: "left"

				},
				SearchsData: [{
					// label: "物流产品",
                    label: " 承运商",
					tag: 'vSelect',
					key: 'EQ_carrierGroupName',
					show: true,
					options:this.truckCarrierGroupList,
                    props:{
						filterable:true,
						clearable:true
                    },
				},{
					label: "物流产品服务",
					tag: 'vInput',
					key: 'CN_code',
					show: true,
				}],
				columns: [{
					type: 'selection',
					width: 60,
					align: "center",
					formName: 'id',
					isRadio:true,
				}, {
					title: "产品物流",
					key: 'carrierGroupName'
				}, {
					title: "产品物流服务",
					key: 'code'
				}]
			}
		}
	},
}
</script>